import Cookies from 'js-cookie'

const LoginKey = 'hasLogin'
const usernameKey = 'username'

export function getToken() {
  return Cookies.get(LoginKey)
}

export function setToken(token) {
  return Cookies.set(LoginKey, token)
}

export function removeToken() {
  return Cookies.remove(LoginKey)
}

export function getUsername() {
  return Cookies.get(usernameKey)
}

export function setUsername(token) {
  return Cookies.set(usernameKey, token)
}

export function removeUsername() {
  return Cookies.remove(usernameKey)
}




// WEBPACK FOOTER //
// ./src/utils/auth.js